<span class="user-select-item">
  <span class="name">{{user?.firstName}} {{user?.lastName}}</span><br/>
  <span class="user-name font-size-small">{{user?.userName}}</span>
</span>
